import React from 'react'
import { useTranslation } from 'react-i18next'
import './WhiteboardNotification.css'
import Modal from '../../../ControlPanel/components/modal/Modal';
import { DialogActions, DialogContent } from '@mui/material';

export default function WhiteboardNotification({ active, onClose, onReset }) {

  const { t } = useTranslation();


  return (<>
    {active && (
      <Modal
        className="whiteboard-notification-modal"
        isOpen={true}
        onClose={onClose}
        header={t('whiteboard_notification')}
      >
        <DialogContent className="whiteboard-notification-container">
          <p>{t('whiteboard_notification_message')}</p>

        </DialogContent>

        <DialogActions className="whiteboard-notification-actions">
          <button className="whiteboard-notification-btn whiteboard-conserve" onClick={(e) => { e.preventDefault(); onClose() }}>{t('conserve_whiteboard')}</button>
          <button className="whiteboard-notification-btn whiteboard-delete" onClick={(e) => { e.preventDefault(); onReset() }}>{t('delete_whiteboard')}</button>
        </DialogActions>
      </Modal>
    )}
  </>
  )
}
